import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Home from './Home/Home.js';
import AllOrders from './OrderPage/AllOrders.js';
import Notification from './Notification/Notification.js';
import AccordionHelp from './Help/AccordionHelp.js';
import RetrictedItem from './RetrictedItem/RetrictedItem.js';
import PackGuidelines from './RetrictedItem/PackGuidelines.js';
import Signup from './user verification/Signup.js';
import TrackCourier from './TrackCourier/TrackCourier.js';
import SingleTrack from './OrderPage/SingleTrack.js';
import CalculatorCourier from './CalculatorCourier/CalculatorCourier.js';
import DocumentShipping from './DocumentShiping/DocumentShipping.js';
import AdminHome from './SuperAdminPanel/AdminHome.js';
import AdminTrack from './SuperAdminPanel/AdminTrack.js';
import AdminTicket from './SuperAdminPanel/AdminTicket.js';
import AdminTotalCustomer from './SuperAdminPanel/AdminTotalCustomer.js';
import AdminAd from './SuperAdminPanel/AdminAd.js';
import AdminPayment from './SuperAdminPanel/AdminPayment.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from "react-router-dom";
import Carousel from './SuperAdminPanel/Carousel.js';
import withSession from './Session/withSession.js';
import TermsAndConditions from './Footer/TermsAndConditions.js';
import PrivacyPolicy from './Footer/PrivacyPolicy.js';
import FraudDisclaimer from './Footer/FraudDisclaimer.js';
import Notfoundpage from './404page/Notfoundpage.js';
import AdminRefund from './SuperAdminPanel/AdminRefund.js';
import AdminTopbar from './SuperAdminPanel/AdminTopbar.js';
import AdminEdit from './SuperAdminPanel/AdminEdit.js';
import AdminPolicy from './SuperAdminPanel/AdminPolicy.js';
import AdminIncome from './SuperAdminPanel/AdminIncome.js';
import ForeignAir from './InternationalCourier/ForeignAir.js';
import Cookies from './Footer/Cookies.js';
import MobileUpdate from './Common/MobileUpdate.js';
import AnotherHelp from './Help/AnotherHelp.js';
import ShippingLabel from './Home/ShippingLabel.js';
import Label from './Home/Label.js';
import NetworkStatus from './networkError/NetworkStatus.js';
import InternationalAllOrders from './InternationalCourier/InternationalAllOrders.js';
import AllOrderSeller from './DomesticSellerOrder/AllOrderSeller.js';
import AllPaymentSeller from './DomesticSellerOrder/AllPaymentSeller.js';
import AdminCodSellerPayment from './SuperAdminPanel/AdminCodSellerPayment.js';
import AdminSingleCodPayment from './SuperAdminPanel/AdminSingleCodPayment.js';
import SellerPrufDetails from './PrufOfSeller/SellerPrufDetails.js';
import AdminAfterFourDayNotPaymentOrder from './SuperAdminPanel/AdminAfterFourDayNotPayment.js';
import AdminPrufSingle from './SuperAdminPanel/AdminPrufSingle.js';
import OpenPendingPickupOrder from './SuperAdminPanel/OpenPendingPickupOrder.js';
import PendingPickupOrderList from './SuperAdminPanel/PendingPickupOrderList.js';
import AdminCustomerDetails from './SuperAdminPanel/AdminCustomerDetails.js';
import Dashboard from './OrderPage/Dashboard.js';
import SideBar from './OrderPage/SideBar.js';
import DashShipment from './OrderPage/DashShipment.js';
import NDRDash from './OrderPage/NDRDash.js';
import Escalations from './OrderPage/Escalations.js';
import BillingHeader from './OrderPage/biling/BillingHeader.js';
import CodRemittances from './OrderPage/biling/CodRemittances.js';
import WalletTransactions from './OrderPage/biling/WalletTransactions.js';
import EarlyCODRemittancePlan from './OrderPage/biling/EarlyCODRemittancePlan.js';
import ShipmentRelated from './OrderPage/escalationfile/ShipmentRelated.js';
import BillingRemittanceRelated from './OrderPage/escalationfile/BillingRemittanceRelated.js';
import TechRelated from './OrderPage/escalationfile/TechRelated.js';
import SingleEscalation from './OrderPage/escalationfile/SingleEscalation.js';
import ViewTableEscalation from './OrderPage/escalationfile/ViewTableEscalation.js';
import DeliveryPage from './DocumentShiping/DeliveryPage.js';
import Settings from './OrderPage/Settings.js';
import SettingsHeader from './OrderPage/SettingsHeader.js';
import SellerGST from './PrufOfSeller/SellerGST.js';
import LabelSetting from './PrufOfSeller/LabelSetting.js';
import CalculateHeader from './CalculatorCourier/CalculateHeader.js';
import CalculateRateShowHeader from './CalculatorCourier/CalculateRateShowHeader.js';
import AdminCustomerShipment from './SuperAdminPanel/AllCustomerDetails/AdminCustomerShipment.js';
import AdminCustomerHeader from './SuperAdminPanel/AllCustomerDetails/AdminCustomerHeader.js';
import AdminCustomerAccount from './SuperAdminPanel/AllCustomerDetails/AdminCustomerAccount.js';
import AdminCustomerBilling from './SuperAdminPanel/AllCustomerDetails/AdminCustomerBilling.js';
import AdminCustomerWallet from './SuperAdminPanel/AllCustomerDetails/AdminCustomerWallet.js';
import AdminCustomerShippingcharges from './SuperAdminPanel/AllCustomerDetails/AdminCustomerShippingcharges.js';
import AdminSingleEscalation from './SuperAdminPanel/AllCustomerDetails/AdminSingleEscalation.js';
import AdminSellerOrderCreate from './SuperAdminPanel/AdminSellerOrderCreate.js';
import AdminForeignPriceListExcel from './SuperAdminPanel/AdminForeignPriceListExcel.js';
import LatestAdminLayout from './LatestSupperAdmin/common/LatestAdminLayout.js';
import AdminDashboard from './LatestSupperAdmin/SidebarAdmin/AdminDashboard.js';
import FranchiseeEnquiry from './Franchisee-enquiry/FranchiseeEnquiry.js';
import AggrementDetailsManager from './LatestSupperAdmin/HubManagerDetails/AggrementDetailsManager.js';
import BankAccountDetailsManagerHUB from './LatestSupperAdmin/HubManagerDetails/BankAccountDetailsManagerHUB.js';
import KYCManagerHUB from './LatestSupperAdmin/HubManagerDetails/KYCManagerHUB.js';
import PersonalInformationManagerHUB from './LatestSupperAdmin/HubManagerDetails/PersonalInformationManagerHUB.js';
import ResidencyAddManager from './LatestSupperAdmin/HubManagerDetails/ResidencyAddManager.js';
import AllMovement from './LatestSupperAdmin/Movement/AllMovement.js';
import ManagerInfoTable from './LatestSupperAdmin/HubManagerDetails/ManagerInfoTable.js';
import SinglePageManagerDetails from './LatestSupperAdmin/HubManagerDetails/SinglePageManagerDetails.js';
import FranchiseAdded from './LatestSupperAdmin/FranchiseAddROListShow/FranchiseAdded.js';
import RODetailsSinglepage from './LatestSupperAdmin/FranchiseAddROListShow/RODetailsSinglepage.js';
import FranchiseAddFrom from './LatestSupperAdmin/FranchiseAddROListShow/FranchiseAddFrom.js';
import FranchiseList from './LatestSupperAdmin/FranchiseAddROListShow/FranchiseList.js';
import FranchiseSinglepage from './LatestSupperAdmin/FranchiseAddROListShow/FranchiseSinglepage.js';
import TodayShipment from './LatestSupperAdmin/Customer Details/TodayShipment.js';
import TodayTicketsAdmin from './LatestSupperAdmin/Customer Details/TodayTicketsAdmin.js';
import NewCustomersOrderadmin from './LatestSupperAdmin/Customer Details/NewCustomersOrderadmin.js';
import OnlineOrderAdmin from './LatestSupperAdmin/Customer Details/OnlineOrderAdmin.js';
import TodayShipmentFranchiseorder from './LatestSupperAdmin/Franchise Details/TodayShipmentFranchiseorder.js';
import NewCustomersOrderFranchisedetails from './LatestSupperAdmin/Franchise Details/NewCustomersOrderFranchisedetails.js';
import InternationalCourierBYfranchise from './LatestSupperAdmin/Franchise Details/InternationalCourierBYfranchise.js';
import TotalFranchiseAdmin from './LatestSupperAdmin/Franchise Details/TotalFranchiseAdmin.js';
import WeightMismatchBYFranchise from './LatestSupperAdmin/Franchise Details/WeightMismatchBYFranchise.js';
import FetchAWBNumbersBYfranchise from './LatestSupperAdmin/Franchise Details/FetchAWBNumbersBYfranchise.js';
import FranchiseComplaintAdmin from './LatestSupperAdmin/Complaint both/FranchiseComplaintAdmin.js';
import DeliveryExecutiveAdmin from './LatestSupperAdmin/Pickup-Delivery Executive/DeliveryExecutiveAdmin.js';
import PickupExecutiveAdmin from './LatestSupperAdmin/Pickup-Delivery Executive/PickupExecutiveAdmin.js';
import WalletShowFranchiseAdmin from './LatestSupperAdmin/Wallet/WalletShowFranchiseAdmin.js';
import AdvertisementAdmin from './LatestSupperAdmin/Social Advertisement/AdvertisementAdmin.js';
import RoFormLayout from './LatestSupperAdmin/HubManagerDetails/RoContext.js';
import ProtectedStepRoute from './LatestSupperAdmin/HubManagerDetails/ProtectedStepRoute.jsx';
import AdminFranchiseEnquiry from './SuperAdminPanel/AdminFranchiseEnquiry.js';
import FranchiseProfileDetails from './LatestSupperAdmin/Franchise Details/FranchiseProfileDetails.js';
import DepositSlip from './LatestSupperAdmin/Franchise Details/DepositeSlip.js';
import TotalCostomerAdmin from './LatestSupperAdmin/Customer Details/TotalCostomerAdmin.js';


function App({ session, refetch }) {





  const login = localStorage.getItem('role');
  const AdminRoute = ({ children, session }) => {
    // console.log('✌️session --->', session);
    // console.log('✌️children --->', children);
    const location = useLocation();
    // console.log('✌️location --->++++', location);
    const me = session?.me;
    // console.log('✌️me --->', me);
    const role = me?.userType;
    // console.log('✌️role --->', role);
    if (role) {
      if (!me || !isAdmin(role)) {
        return <Navigate to="/signup" state={{ from: location }} replace />;
      } else {
        return children;
      }
    } else {

      return children;
    }
  };

  const isAdmin = (role) => {
    if ((role === 'Admin'))
      return true
    else
      return false
  }

  const PublicRoute = ({ children, session }) => {
    const location = useLocation();
    let role = session && session?.me;
    if (role) {
      if (role && isAdmin(role?.userType)) {
        return <Navigate to="/adminhome" state={{ from: location }} replace />;
      } else {
        return children;
      }
    } else {
      return children
    }
  };
  const CustomerRoute = ({ children, session }) => {
    const location = useLocation();
    let role = session && session?.me;
    if (role || login) {
      if (role && isAdmin(role?.userType) || login === 'Admin') {
        return <Navigate to="/adminhome" state={{ from: location }} replace />;
      } else if (role && role?.userType === "User" || login === 'User') {
        return children;
      } else {
        return <Navigate to="/signup" state={{ from: location }} replace />;
      }
    } else {
      return <Navigate to="/signup" state={{ from: location }} replace />;
    }
  };
  return (
    <>
      <BrowserRouter>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          limit={2}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <NetworkStatus />

        <Routes>
          {/* //public routes */}
          <Route exact path="/" element={<PublicRoute session={session}><Home /></PublicRoute>} />
          <Route exact path="/signup" element={<PublicRoute session={session}><Signup refetch={refetch} /></PublicRoute>} />
          <Route exact path="/packguidlines" element={<PublicRoute session={session}><PackGuidelines refetch={refetch} /></PublicRoute>} />
          <Route exact path="/trackcourier" element={<PublicRoute session={session}><TrackCourier refetch={refetch} /></PublicRoute>} />
          <Route exact path="/calculatorcourier" element={<PublicRoute session={session}><CalculatorCourier refetch={refetch} /></PublicRoute>} />
          <Route exact path="/termsAndConditions" element={<PublicRoute session={session}><TermsAndConditions refetch={refetch} /></PublicRoute>} />
          <Route exact path="/privacyPolicy" element={<PublicRoute session={session}><PrivacyPolicy refetch={refetch} /></PublicRoute>} />
          <Route exact path="/cookiespolicy" element={<PublicRoute session={session}><Cookies refetch={refetch} /></PublicRoute>} />
          <Route exact path="/fraudDisclaimer" element={<PublicRoute session={session}><FraudDisclaimer refetch={refetch} /></PublicRoute>} />
          <Route exact path="/notfoundpage" element={<PublicRoute session={session}><Notfoundpage refetch={refetch} /></PublicRoute>} />
          <Route exact path="/retrictedItem" element={<PublicRoute session={session}>{<RetrictedItem />}</PublicRoute>} />
          <Route exact path="/accordionhelp" element={<PublicRoute session={session}>{<AccordionHelp />}</PublicRoute>} />
          <Route exact path="/notification" element={<PublicRoute session={session}>{<Notification />}</PublicRoute>} />
          <Route exact path="/foreignair" element={<PublicRoute session={session}>{<ForeignAir />}</PublicRoute>} />
          <Route exact path="/anotherhelp" element={<PublicRoute session={session}>{<AnotherHelp />}</PublicRoute>} />
          <Route exact path="/shippinglabel" element={<PublicRoute session={session}>{<ShippingLabel />}</PublicRoute>} />
          <Route exact path="/label" element={<PublicRoute session={session}>{<Label />}</PublicRoute>} />
          <Route exact path="/calculateheader" element={<PublicRoute session={session}>{<CalculateHeader />}</PublicRoute>} />
          <Route exact path="/calculatorrateshowheader" element={<PublicRoute session={session}>{<CalculateRateShowHeader />}</PublicRoute>} />
          <Route exact path="/franchiseeenquiry" element={<PublicRoute session={session}>{<FranchiseeEnquiry />}</PublicRoute>} />




          <Route exact path="/allOrders" element={<CustomerRoute session={session}>{<AllOrders />}</CustomerRoute>} />
          <Route exact path="/allOrderseller" element={<CustomerRoute session={session}>{<AllOrderSeller />}</CustomerRoute>} />
          <Route exact path="/allpaymentseller" element={<CustomerRoute session={session}>{<AllPaymentSeller />}</CustomerRoute>} />
          <Route exact path="/sellerprufdetails" element={<CustomerRoute session={session}><SellerPrufDetails /></CustomerRoute>} />
          <Route exact path="/internationalAllOrders" element={<CustomerRoute session={session}>{<InternationalAllOrders />}</CustomerRoute>} />
          <Route exact path="/documentshipping" element={<CustomerRoute session={session}>{<DocumentShipping session={session} />}</CustomerRoute>} />
          {/* <Route exact path="/bulkcourier" element={<CustomerRoute session={session}>{<BulkCourier />}</CustomerRoute>} /> */}
          <Route exact path="/singletrack" element={<CustomerRoute session={session}>{<SingleTrack />}</CustomerRoute>} />
          <Route exact path="/dashboard" element={<CustomerRoute session={session}>{<Dashboard />}</CustomerRoute>} />
          <Route exact path="/dashshipment" element={<CustomerRoute session={session}>{<DashShipment />}</CustomerRoute>} />
          <Route exact path="/ndrdash" element={<CustomerRoute session={session}>{<NDRDash />}</CustomerRoute>} />
          <Route exact path="/sidebar" element={<CustomerRoute session={session}>{<SideBar />}</CustomerRoute>} />
          <Route exact path="/escalations" element={<CustomerRoute session={session}>{<Escalations />}</CustomerRoute>} />
          <Route exact path="/billingheader" element={<CustomerRoute session={session}>{<BillingHeader />}</CustomerRoute>} />
          <Route exact path="/CodRemittances" element={<CustomerRoute session={session}>{<CodRemittances />}</CustomerRoute>} />
          <Route exact path="/wallettransactions" element={<CustomerRoute session={session}>{<WalletTransactions />}</CustomerRoute>} />
          <Route exact path="/earlycodremittanceplan" element={<CustomerRoute session={session}>{<EarlyCODRemittancePlan />}</CustomerRoute>} />
          <Route exact path="/shipmentrelated" element={<CustomerRoute session={session}>{<ShipmentRelated />}</CustomerRoute>} />
          <Route exact path="/billingremittancerelated" element={<CustomerRoute session={session}>{<BillingRemittanceRelated />}</CustomerRoute>} />
          <Route exact path="/techrelated" element={<CustomerRoute session={session}>{<TechRelated />}</CustomerRoute>} />
          <Route exact path="/singleescalation" element={<CustomerRoute session={session}>{<SingleEscalation />}</CustomerRoute>} />
          <Route exact path="/viewtableescalation" element={<CustomerRoute session={session}>{<ViewTableEscalation />}</CustomerRoute>} />
          <Route exact path="/settings" element={<CustomerRoute session={session}>{<Settings />}</CustomerRoute>} />
          <Route exact path="/settingsheader" element={<CustomerRoute session={session}>{<SettingsHeader />}</CustomerRoute>} />
          <Route exact path="/sellergst" element={<CustomerRoute session={session}>{<SellerGST />}</CustomerRoute>} />
          <Route exact path="/labelsetting" element={<CustomerRoute session={session}>{<LabelSetting />}</CustomerRoute>} />


          {/* <Route path="/order" element={<Orders />} /> */}
          {/* <Route exact path="/singleEscalationAdmin" element={<AdminRoute session={session}>{<AdminSingleEscalation />}</AdminRoute>} /> */}
          <Route path="/adminhome" element={<AdminRoute session={session}><AdminHome /></AdminRoute>} />
          <Route path="/adminPrufSingle" element={<AdminRoute session={session}><AdminPrufSingle /></AdminRoute>} />

          <Route path="/admintrack" element={<AdminRoute session={session}><AdminTrack /></AdminRoute>} />
          {/* <Route path="/adminticket" element={<AdminRoute session={session}><AdminTicket /></AdminRoute>} /> */}

          <Route path="/admintotalcustomerordercreate" element={<AdminRoute session={session}><AdminSellerOrderCreate /></AdminRoute>} />
          <Route path="/adminpayment" element={<AdminRoute session={session}><AdminPayment /></AdminRoute>} />
          <Route path="/adminCodSellerPayment" element={<AdminRoute session={session}><AdminCodSellerPayment /></AdminRoute>} />
          <Route path="/adminCodMissSellerPayment" element={<AdminRoute session={session}><AdminAfterFourDayNotPaymentOrder /></AdminRoute>} />
          <Route path="/openPendingPickupOrder" element={<AdminRoute session={session}><OpenPendingPickupOrder /></AdminRoute>} />
          <Route path="/adminSingleCodPayment" element={<AdminRoute session={session}><AdminSingleCodPayment /></AdminRoute>} />
          <Route path="/PendingPickupOrderList" element={<AdminRoute session={session}><PendingPickupOrderList /></AdminRoute>} />
          <Route path="/AdminRefund" element={<AdminRoute session={session}><AdminRefund /></AdminRoute>} />
          <Route path="/AdminEdit" element={<AdminRoute session={session}><AdminEdit /></AdminRoute>} />
          <Route path="/AdminIncome" element={<AdminRoute session={session}><AdminIncome /></AdminRoute>} />
          <Route path="/admincustomershipment" element={<AdminRoute session={session}><AdminCustomerShipment /></AdminRoute>} />
          <Route path="/admincustomerheader" element={<AdminRoute session={session}><AdminCustomerHeader /></AdminRoute>} />
          <Route path="/adminforeignpricelistexcel" element={<AdminRoute session={session}><AdminForeignPriceListExcel /></AdminRoute>} />
          <Route path="/submit-delivery/:customerId" element={<DeliveryPage />} />




          <Route path="*" element={<Notfoundpage />} />


          {/* LatestAdminLayout */}
          <Route element={<AdminRoute session={session}><LatestAdminLayout session={session} /></AdminRoute>}>
            <Route element={<RoFormLayout />}>
              <Route path="/personalinformationmanagerhub" element={<ProtectedStepRoute path="/personalinformationmanagerhub" element={PersonalInformationManagerHUB} />} />
              <Route path="/residencyaddmanager" element={<ProtectedStepRoute path="/residencyaddmanager" element={ResidencyAddManager} />} />
              <Route path="/kycmanagerhub" element={<ProtectedStepRoute path="/kycmanagerhub" element={KYCManagerHUB} />} />
              <Route path="/bankaccountdetailsmanagerhub" element={<ProtectedStepRoute path="/bankaccountdetailsmanagerhub" element={BankAccountDetailsManagerHUB} />} />
              <Route path="/aggrementdetailsmanager" element={<ProtectedStepRoute path="/aggrementdetailsmanager" element={AggrementDetailsManager} />} />
            </Route>

            <Route path="/admindashboard" element={<AdminDashboard session={session} />} />
            <Route path="/allmovement" element={<AllMovement />} />
            <Route path="/managerinfotable" element={<ManagerInfoTable />} />
            <Route path="/singlepagemanagerdetails" element={<SinglePageManagerDetails />} />
            <Route path="/franchiseadded" element={<FranchiseAdded />} />
            <Route path="/rodetailssinglepage" element={<RODetailsSinglepage />} />
            <Route path="/franchiseaddfrom" element={<FranchiseAddFrom />} />
            <Route path="/franchiselist" element={<FranchiseList />} />
            <Route path="/franchisesinglepage" element={<FranchiseSinglepage />} />
            <Route path="/shippingchargesAdmin" element={<AdminCustomerShippingcharges />} />
            <Route path="/carousel" element={<Carousel />} />
            <Route path="/adminad" element={<AdminAd />} />
            <Route path="/AdminPolicy" element={<AdminPolicy />} />
            <Route path="/AdminTopbar" element={<AdminTopbar />} />
            <Route path="/adminfranchiseenquiry" element={<AdminFranchiseEnquiry />} />








            <Route path="/todayshipment" element={<TodayShipment />} />

            <Route path="/todayticketsadmin" element={<TodayTicketsAdmin />} />
            <Route path="/adminticket" element={<AdminTicket />} />
            <Route path="/singleEscalationAdmin" element={<AdminSingleEscalation />} />
            <Route path="/admintotalcustomer" element={<AdminTotalCustomer />} />
            <Route path="/admincustomeraccount" element={<AdminCustomerAccount />} />
            <Route path="/adminCustomerDetails" element={<AdminCustomerDetails />} />
            <Route path="/codRemmitanceAdmin" element={<AdminCustomerBilling />} />
            <Route path="/wallettransactionsAdmin" element={<AdminCustomerWallet />} />







            <Route path="/newcustomersorderadmin" element={<NewCustomersOrderadmin />} />
            <Route path="/totalcostomeradmin" element={<TotalCostomerAdmin />} />
            <Route path="/onlineorderadmin" element={<OnlineOrderAdmin />} />

            {/* Franchise Details */}
            <Route path="/todayshipmentfranchiseorder" element={<TodayShipmentFranchiseorder />} />
            <Route path="/newcustomersorderfranchisedetails" element={<NewCustomersOrderFranchisedetails />} />
            <Route path="/internationalcourierbyfranchise" element={<InternationalCourierBYfranchise />} />
            <Route path="/totalfranchiseadmin" element={<TotalFranchiseAdmin />} />
            <Route path="/franchiseprofiledetails" element={<FranchiseProfileDetails />} />

            <Route path="/DepositSlip" element={<DepositSlip />} />
            <Route path="/weightmismatchbyfranchise" element={<WeightMismatchBYFranchise />} />
            <Route path="/fetchawbnumbersbyfranchise" element={<FetchAWBNumbersBYfranchise />} />

            {/* Complaint both */}
            <Route path="/franchisecomplaintadmin" element={<FranchiseComplaintAdmin />} />


            {/* Pickup-Delivery Executive */}
            <Route path="/deliveryexecutivesdmin" element={<DeliveryExecutiveAdmin />} />
            <Route path="/pickupexecutiveadmin" element={<PickupExecutiveAdmin />} />


            {/* Wallet */}
            <Route path="/walletshowfranchiseadmin" element={<WalletShowFranchiseAdmin />} />

            {/* Social Advertisement */}
            <Route path="/advertisementadmin" element={<AdvertisementAdmin />} />
          </Route>
        </Routes>
        <MobileUpdate />
      </BrowserRouter>

    </>
  );
}

export default withSession(App);
